<ng-container *ngFor="let field of params.fields;">

  <ng-container *ngIf="field.visible" [service]="service" [field]="field" [group]="form" gioFormField>
  </ng-container>


</ng-container>
